import React, { FunctionComponent, useState } from "react";
import {appDefaultFilters,FiltersContext} from "../../service/filters";
import { BrowserRouter } from "react-router-dom";
import { I18nProvider, TranslationProvider } from "../../service/translation";
import { ThemeOptions } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/core";
import {ThemeContext,lightTheme} from "../../config/theme";
import CssBaseline from "@material-ui/core/CssBaseline";


interface NewshubContextProps {
    children: any,
    i18nProvider: I18nProvider,
    theme?: ThemeOptions,
}

const NewshubContext: FunctionComponent<NewshubContextProps> = (props: NewshubContextProps) => {
    const {
        children,
        i18nProvider,
    } = props;

    const [filters,setFilters] = useState(appDefaultFilters);
    const [currentTheme,setCurrentTheme] = useState(lightTheme);

    return (
        <TranslationProvider i18nProvider={i18nProvider}>
            <BrowserRouter>
            <ThemeContext.Provider value={[currentTheme,setCurrentTheme]}>
                <ThemeProvider theme={currentTheme}>
                    <CssBaseline/>
                    <FiltersContext.Provider value={[filters,setFilters]}>
                        {children}
                    </FiltersContext.Provider>
                </ThemeProvider>
            </ThemeContext.Provider>
            </BrowserRouter>
        </TranslationProvider>
    );
};

export default NewshubContext;
